<template>
  <div class="chat-group-card" @click.stop="onShowGroupInfo">
    <div class="card-body">
      <head-image :url="cardInfo.headImage" :name="cardInfo.groupName" radius="10%"></head-image>
      <div class="nick-name">
        {{ cardInfo.groupName }}
      </div>
    </div>
    <div class="card-footer">
      <div class="tip">群名片</div>
      <el-tag v-if="isExpired" type="warning">已过期</el-tag>
    </div>
  </div>
</template>
<script>
import HeadImage from '../common/HeadImage.vue'

export default {
  name: "chatUserCard",
  components: {
    HeadImage
  },
  props: {
    sendTime: {
      type: Number,
      default: null
    },
    cardInfo: {
      type: Object
    }
  },
  data() {
    return {}
  },
  methods: {
    onShowGroupInfo(e) {
      if (this.isExpired) {
        this.$message.warning("该名片已过期")
        return;
      }
      this.$http({
        url: `/group/find/${this.cardInfo.groupId}`,
        method: 'get'
      }).then(group => {
        let pos = {
          x: e.x + 30,
          y: e.y
        }
        this.$eventBus.$emit("openGroupInfo", group, this.cardInfo.token, pos);
      })
    }
  },
  computed: {
    isExpired() {
      if (!this.cardInfo.token || !this.cardInfo.token.expiredIn) {
        return true;
      }
      return new Date().getTime() > this.cardInfo.token.expiredIn
    }
  }
}
</script>
<style scoped lang="scss">
.chat-group-card {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  box-shadow: var(--im-box-shadow-light);
  border-radius: 10px;
  padding: 8px 15px;
  height: 80px;
  width: 180px;
  cursor: pointer;
  border: 2px solid #eee;

  .card-body {
    flex: 1;
    display: flex;
    align-items: center;
    border-bottom: 2px solid #eee;

    .nick-name {
      margin-left: 8px;
      font-weight: 600;
      font-size: var(--im-font-size);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .card-footer {
    display: flex;
    align-items: center;
    margin-top: 4px;
    width: 100%;
    color: var(--im-text-color-light);
    font-size: var(--im-font-size-smaller);
    text-align: left;

    .tip {
      flex: 1;
    }
  }
}
</style>
